import { API_URL, getAuthHeaders, getAuthOptions } from "./api";

export const getUnreadCount = async () => {
  const response = await fetch(`${API_URL}/api/notifications/unread-count`, {
    method: "GET",
    headers: getAuthHeaders(),
    ...getAuthOptions(),
  });
  if (!response.ok) {
    if (response.status === 401) throw new Error("Unauthorized");
    throw new Error("Failed to fetch unread count");
  }
  return response.json();
};

export const listNotifications = async ({ pageParam = null, limit = 20, unreadOnly = false }) => {
  const params = new URLSearchParams();
  if (pageParam) params.append("cursor", pageParam);
  params.append("limit", limit);
  if (unreadOnly) params.append("unreadOnly", "true");

  const response = await fetch(`${API_URL}/api/notifications?${params.toString()}`, {
    method: "GET",
    headers: getAuthHeaders(),
    ...getAuthOptions(),
  });

  if (!response.ok) {
    if (response.status === 401) throw new Error("Unauthorized");
    throw new Error("Failed to load notifications");
  }
  return response.json();
};

export const markRead = async (id) => {
  const response = await fetch(`${API_URL}/api/notifications/${id}/read`, {
    method: "POST",
    headers: getAuthHeaders(),
    ...getAuthOptions(),
  });
  if (!response.ok) {
    if (response.status === 401) throw new Error("Unauthorized");
    throw new Error("Failed to mark as read");
  }
  return response.json();
};

/**
 * Marks several notifications read in one request. Used by the
 * "read once it scrolls into view" behaviour, which would otherwise spend one
 * write per row against a 30/minute budget shared with the rest of the app.
 */
export const markManyRead = async (ids) => {
  const response = await fetch(`${API_URL}/api/notifications/read`, {
    method: "POST",
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ ids }),
    ...getAuthOptions(),
  });
  if (!response.ok) {
    if (response.status === 401) throw new Error("Unauthorized");
    throw new Error("Failed to mark notifications as read");
  }
  return response.json();
};

export const markAllRead = async () => {
  const response = await fetch(`${API_URL}/api/notifications/read-all`, {
    method: "POST",
    headers: getAuthHeaders(),
    ...getAuthOptions(),
  });
  if (!response.ok) {
    if (response.status === 401) throw new Error("Unauthorized");
    throw new Error("Failed to mark all as read");
  }
  return response.json();
};

export const deleteNotification = async (id) => {
  const response = await fetch(`${API_URL}/api/notifications/${id}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
    ...getAuthOptions(),
  });
  if (!response.ok) {
    if (response.status === 401) throw new Error("Unauthorized");
    throw new Error("Failed to delete notification");
  }
  return response.json();
};

export const getPreferences = async () => {
  const response = await fetch(`${API_URL}/api/notifications/preferences`, {
    method: "GET",
    headers: getAuthHeaders(),
    ...getAuthOptions(),
  });
  if (!response.ok) {
    if (response.status === 401) throw new Error("Unauthorized");
    throw new Error("Failed to fetch preferences");
  }
  return response.json();
};

export const updatePreferences = async (data) => {
  const response = await fetch(`${API_URL}/api/notifications/preferences`, {
    method: "PATCH",
    headers: getAuthHeaders(),
    ...getAuthOptions(),
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    if (response.status === 401) throw new Error("Unauthorized");
    throw new Error("Failed to update preferences");
  }
  return response.json();
};
